import React from 'react';

const periods = [
  { key: 'today', label: 'Bugün' },
  { key: 'yesterday', label: 'Dün' },
  { key: 'thisWeek', label: 'Bu Hafta' },
  { key: 'thisMonth', label: 'Bu Ay' },
  { key: 'custom', label: 'Özel' },
];

const Filters = ({ activePeriod, onChange, startDate, endDate, onStartDateChange, onEndDateChange }) => (
  <div className="flex flex-wrap items-center gap-2">
    {periods.map(p => (
      <button key={p.key} onClick={() => onChange(p.key)}
        className={`px-3.5 py-1.5 text-[11px] font-semibold rounded-xl transition-all ${
          activePeriod === p.key
            ? 'bg-emerald-500 text-white shadow-md shadow-emerald-500/20'
            : 'bg-white dark:bg-surface-700 text-surface-500 dark:text-surface-400 border border-surface-200 dark:border-surface-600 hover:bg-surface-50 dark:hover:bg-surface-600'
        }`}>
        {p.label}
      </button>
    ))}
    {activePeriod === 'custom' && (
      <div className="flex items-center gap-2 ml-2">
        <input type="date" value={startDate} onChange={e => onStartDateChange(e.target.value)}
          className="px-2.5 py-1.5 text-[11px] border border-surface-200 dark:border-surface-600 rounded-xl bg-white dark:bg-surface-700 text-surface-700 dark:text-surface-300" />
        <span className="text-[11px] text-surface-400">-</span>
        <input type="date" value={endDate} onChange={e => onEndDateChange(e.target.value)}
          className="px-2.5 py-1.5 text-[11px] border border-surface-200 dark:border-surface-600 rounded-xl bg-white dark:bg-surface-700 text-surface-700 dark:text-surface-300" />
      </div>
    )}
  </div>
);

export default Filters;
